window.addEventListener("load", (e) => {
    const form = document.querySelector(".feedback-form");
    if (!form) return;

    const stars = form.querySelectorAll(".star-rating .gfield_radio .gchoice input");
    if (!stars) return;

    stars.forEach((star) => {
        star.addEventListener("click", (e) => {
            const endIndex = star.value-1;
            let i = 0;
            stars.forEach((innerStar) => {
                if (i !== endIndex) {
                    innerStar.classList.add("glowing");
                    i += 1;
                } else {
                    innerStar.classList.remove("glowing");
                }
            })
        });

        star.addEventListener("mouseenter", (e) => {
            const endIndex = star.value-1;
            let i = 0;
            while (i !== endIndex && i < stars.length){
                stars[i].classList.add("hover-glow");
                i+=1;
            }
        });

        star.addEventListener("mouseleave", (e) => {
            const glowingStars = form.querySelectorAll(".star-rating .gfield_radio .gchoice input.hover-glow");
            glowingStars.forEach((glowing) => {
                glowing.classList.remove("hover-glow");
            })
        });
    })

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (!urlParams.has("form") && !urlParams.get("form")) return;


    const confirmation = document.querySelector(".feedback-confirmation");
    if (!confirmation) return;
    form.classList.add("hidden");

    confirmation.classList.remove("hidden");

    if (urlParams.has("newsletter") && urlParams.get("newsletter") !== "") {
        const p = confirmation.querySelector(".newletter-ordered");
        if (!!p) p.classList.remove("hidden");

    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
})